import React from "react";
import { Avatar, Box, Button, Card, Stack, Typography } from "@mui/material";
import { Download } from "lucide-react";
import styles from "./cisoDashboard.module.scss";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
const complianceData = [
  {
    framework: "ISO 27001",
    progress: 94,
    controls: "114/121",
    tone: "success",
    type: "On Track",
  },
  {
    framework: "IEC 62443",
    progress: 87,
    controls: "67/77",
    tone: "warning",
    type: "On Track",
  },
  {
    framework: "NIST CSF",
    progress: 91,
    controls: "98/108",
    tone: "danger",
    type: "On Track",
  },
  {
    framework: "HIPAA",
    progress: 78,
    controls: "42/54",
    tone: "danger",
    type: "Needs Attention",
  },
  {
    framework: "HIPAA",
    progress: 94,
    controls: "42/54",
    tone: "success",
    type: "On Track",
  },
];

const toneColor = {
  success: "#10b981",
  warning: "#f59e0b",
  danger: "#ef4444",
};

export const ComplianceAuditPanel = ({ handleNavigate }) => {
  return (
    <Card
      className={styles.card}
      sx={{ borderRadius: 2, width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Box className={styles.sectionTitleRow}>
        <Box display="flex" alignItems="center" gap={1}>
          <Box>
            <Typography className={styles.sectionHeading} fontWeight={600}>
              Compliance Framework Progress{" "}
            </Typography>
          </Box>
        </Box>
        {/* <Button
          variant="contained"
          sx={{ borderRadius: 2, bgcolor: "rgba(5, 117, 230, 1)" }}
          startIcon={<Download size={16} />}
        >
          Generate Evidence (PDF)
        </Button> */}
      </Box>

      <Box className={styles.list}>
        {complianceData.map((item) => (
          <Stack key={item.framework}>
            <Stack
              direction="row"
              gap={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => handleNavigate("hipaa-compliance")}
            >
              <Stack direction="row" gap={2} mt={2}>
                <Avatar
                  variant="rounded"
                  sizes="48"
                  sx={{ bgcolor: toneColor[item.tone] }}
                >
                  <GppGoodOutlinedIcon />
                </Avatar>
                <Box>
                  <Typography
                    fontWeight={700}
                    sx={{
                      "&:hover": {
                        color: "#0575E6",
                      },
                    }}
                  >
                    {item.framework}
                  </Typography>
                  <Typography className={styles.subtitle}>
                    {item.controls} controls
                  </Typography>
                </Box>
              </Stack>
              <Box sx={{ textAlign: "end" }}>
                <Typography fontWeight={700} color={toneColor[item.tone]}>
                  {item.progress}%
                </Typography>
                <Typography
                  fontWeight={500}
                  fontSize={14}
                  color={toneColor[item.tone]}
                >
                  {item.type}
                </Typography>
              </Box>
            </Stack>
            <Box flex="1">
              <Box className={styles.progressBar} height={"10px"}>
                <Box
                  className={styles.progressFill}
                  sx={{
                    width: `${item.progress}%`,
                    background: toneColor[item.tone],
                  }}
                />
              </Box>
            </Box>
          </Stack>
        ))}
      </Box>
    </Card>
  );
};

export default ComplianceAuditPanel;
